/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class NotificationAPI
 * @hideconstructor
 * @classdesc API class that is used for notifications
 */
define(() => {
	class NotificationAPI {
		/**
		 * @function NotificationAPI#setMessage
		 * @description shows a notification with a message
		 * @return {String} message
		 */
		setMessage() {}
	}
	return NotificationAPI;
});
